// Utility to reset the install banner for testing
// Call this in browser console to reset: window.resetInstallBanner()

export function resetInstallBanner() {
  localStorage.removeItem('app-download-banner-dismissed');
  console.log('🔄 Install banner reset - reload page to see banner again');
}

// Make it available globally for testing
if (typeof window !== 'undefined') {
  (window as any).resetInstallBanner = resetInstallBanner;
}